/*
 * Cuántas filas de una tabla caben en la ventana sin hacer scroll.
 *
 * Se usa para pedirle al backend un tamaño de página que llene la pantalla:
 * 6 filas en una laptop de 720px de alto, 10 en un monitor grande. Todas las
 * medidas salen del DOM real (posición de la tabla, alto de cabecera, fila y
 * pie), no de constantes.
 */
export function filasQueCaben({ altoVentana, inicioTabla, altoCabecera, altoFila, altoPie, minimo = 5, maximo = 10 }) {
  if (!altoFila || altoFila <= 0) return minimo
  const disponible = altoVentana - inicioTabla - altoCabecera - altoPie
  const filas = Math.floor(disponible / altoFila)
  return Math.min(maximo, Math.max(minimo, filas))
}

/* Al cambiar el tamaño de página, conserva visible el primer registro. */
export function paginaEquivalente(paginaActual, limiteAnterior, limiteNuevo) {
  const primerIndice = (paginaActual - 1) * limiteAnterior
  return Math.floor(primerIndice / limiteNuevo) + 1
}
